import { useRecoilValue } from "recoil"

import { activeFileMetadataSelector, activePluginSelector } from "../selectors"

/**
 * Hook to access plugin and file metadata without being affected by code content changes
 * This prevents unnecessary re-renders when the code in the editor changes
 */
export function usePluginMetadata() {
  // Get the active plugin and file metadata (without code content)
  const activePlugin = useRecoilValue(activePluginSelector)
  const activeFileMetadata = useRecoilValue(activeFileMetadataSelector)

  return {
    activePlugin,
    activeFileMetadata,
  }
}
